import {
  PostCardListLoading,
  SidebarCardLoading,
} from '@tribeplatform/react-components/LoadingStates'

export const SpaceLoading = () => (
  <div className="space-y-5">
    <div className="bg-surface-50 shadow sm:rounded-lg">
      <div className="h-16 lg:h-24 bg-surface-300 rounded-t-md"></div>
      <div className="flex space-x-4 px-4 py-6 sm:px-6 lg:px-8 items-center">
        <div className="flex justify-between animate-pulse flex-1">
          <div className="h-8 bg-surface-300 rounded-full w-1/4" />
          <div className="h-8 bg-surface-300 rounded-full w-1/4" />
        </div>
      </div>
    </div>
    <div className="grid grid-cols-12 gap-5">
      <div className="web:col-span-12 web:sm:col-span-8 space-y-5">
        <PostCardListLoading />
      </div>
      <div className="hidden web:sm:col-span-4 sm:flex flex-col space-y-5">
        <SidebarCardLoading count={2} />
      </div>
    </div>
  </div>
)
